import React, {Fragment, useRef, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import Config from '../../../Config';
import {} from '../PortalsBlock/portalSlice';
import {
  changePhoneInputHandlerWithExtendedPhone,
  validateCustomerTypeBusinessIndividual,
  setActiveLobbyTab,
  clearOtpFormPhone,
  saveToHistory,
  clearBusinessIndividualSelectedAccountError,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {customerTypeEnum, pages} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import {Col, Row, Button} from 'reactstrap';
import HeadLineComponent from './HeadlineComponent';
import InputText from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {
  gaSelectAccountComponentView,
  gaSelectAccountViewOnlyButtonClick,
  gaSelectAccountContinueButtonClick,
  gaSelectAccountErrorMessage,
} from './GaReports';

const SelectAccountComponent = (props) => {
  const ref = useRef();

  useEffect(() => {
    props.saveToHistory('select_account');
  }, [props.portalsBlock.selectedHetPay]);

  useEffect(() => {
    ref.current?.focus();
    gaSelectAccountComponentView();
    return () => {
      props.clearOtpFormPhone();
    };
  }, []);

  const validateAccount = () => {
    gaSelectAccountContinueButtonClick();
    const otpObj = {
      phoneNumber: props.data.otpPhoneForm.phone,
      type: customerTypeEnum.BUSINESS,
      orgId: props.portalsBlock.privateCompanyList.find((org) => org.idNumber == props.portalsBlock.selectedHetPay).orgId,
    };

    props.validateCustomerTypeBusinessIndividual(otpObj);
  };

  const showAbroadPackagesWithoutPurchase = async () => {
    gaSelectAccountViewOnlyButtonClick();
    props.goToAbroadLobby(true);
  };
  const getCustomerValidationErrorDescription = () => {
    let error;
    if (!props.data.businessIndividualData.isSelectedAccountBelongsToSelectedHetPay) {
      error = `מנוי זה לא שייך לארגון`;
    } else if (!props.data.businessIndividualData.dummySubIndIsNull) {
      error = `המספר שהוזן הינו משני, לא ניתן להמשיך`;
    } else {
      error = `מנוי מושהה, לא ניתן להמשיך`;
    }
    gaSelectAccountErrorMessage(error);
    return error;
  };
  const changePhoneInputHandler = (target, form) => {
    if (
      !props.data.businessIndividualData.isSelectedAccountBelongsToSelectedHetPay ||
      !props.data.businessIndividualData.subStatusIsA ||
      !props.data.businessIndividualData.dummySubIndIsNull
    ) {
      props.clearBusinessIndividualSelectedAccountError();
    }
    props.changePhoneInputHandlerWithExtendedPhone({target: target, form: form});
  };
  return (
    <>
      <HeadLineComponent title={`${window.Config.brand_Name_HE} חו״ל`} boldTitle={'מי טס?'} />
      <Row>
        <Col>
          <div className={`background-container`}>
            <InputText
              className='otp-phone-input'
              ref={ref}
              name='phone'
              type='tel'
              pattern='[0-9]*'
              id='phone'
              maxLength='10'
              autoComplete='off'
              placeholder={props.placeholder ?? 'הזן מנוי סלולר השייך לחברה'}
              required='required'
              value={props.data.otpPhoneForm.phone}
              error={props.data.otpPhoneForm.errors.phone}
              onChange={(e) => changePhoneInputHandler(e.target, props.data.otpPhoneForm)}
            />
          </div>
        </Col>
      </Row>
      {!props.data.businessIndividualData.isSelectedAccountBelongsToSelectedHetPay ||
      !props.data.businessIndividualData.subStatusIsA ||
      !props.data.businessIndividualData.dummySubIndIsNull ? (
        <Row className='account-denied text-center'>
          <Col xs='12' className='justify-content-center pr-0 pl-0'>
            <p className='font-14 newPurple-text mb-1'>{getCustomerValidationErrorDescription()}</p>
          </Col>
          <Col xs='12' className='justify-content-center pr-0 pl-0'>
            {isMobile ? (
              <a href={`tel:${window.Config.businessCallNumber}`} className='font-14 bold asBtn'>
                חיוג 234* לשיחה עם צוותון שירות
              </a>
            ) : (
              <p className='font-14 bold mb-0'>חיוג 234* לשיחה עם צוותון שירות</p>
            )}
          </Col>
        </Row>
      ) : (
        <Row className='justify-content-center'>
          <Col xs='12' className={`mt-30 text-center`}>
            <p className='font-14'>טס יותר מאדם אחד? - בסוף התהליך תוכל לרכוש בקלות לאדם נוסף</p>
          </Col>
        </Row>
      )}

      <Row className='justify-content-center mt-75'>
        <Col
          xs='12'
          className={`btn-220 btn-row pr-0 pl-0 text-center ${
            props.portalsBlock.selectedHetPayAllowedToActions && (!props.data.otpPhoneForm.phone || props.data.otpPhoneForm.errors.phone)
              ? 'disabled-btn'
              : ''
          }`}>
          <BtnSubmit isBusiness text={`המשך`} onclick={() => validateAccount()} />
        </Col>
      </Row>
      {!props.data.selectedAbroadPackage && props.data.page == pages.LOBBY && (
        <Row className='justify-content-center mt-40'>
          <Col xs='12' className={`pr-0 pl-0 text-center `}>
            <Button color='link' className='pink-text' onClick={() => showAbroadPackagesWithoutPurchase()}>
              אף אחד לא טס, רק רוצה לצפות בחבילות
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    portalsBlock: state.portalsBlock,
  };
};

const mapDispatchToProps = {
  changePhoneInputHandlerWithExtendedPhone,
  validateCustomerTypeBusinessIndividual,
  setActiveLobbyTab,
  clearOtpFormPhone,
  saveToHistory,
  clearBusinessIndividualSelectedAccountError,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectAccountComponent);
